/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ONE_TIME: 'onetime',
    CUSTOM: 'custom',
    REPEATEDLY: 'repeatedly',
};
